import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { BreadcrumbsComponent } from "./containers/breadcrumbs.component";

const routes: Routes = [
	{
		path: "",
		component: BreadcrumbsComponent
	}
];

@NgModule({
	declarations: [],
	imports: [[RouterModule.forChild(routes)]],
	exports: [RouterModule]
})
export class BreadcrumbsRoutingModule {}
